import { LoginForm } from '../features/Login/LoginForm';

export function LoginPage() {
  return (
    <div className="p-4 md:p-10 md:pt-20 h-screen bg-neutrals-v2-200 flex justify-center">
      <LoginForm />
    </div>
  );
}
